<template>
  <loader-full v-if="isOtpSended === null && isOtpAccepted === null" :text="'Загрузка'"/>
  <template v-else>
    <template v-if="!isOtpAccepted">
      <div v-if="isOtpSended" class="p-3 d-flex justify-content-center" style="height: 100dvh">
        <div class="col-md-6 card h-100 p-2 d-flex flex-column">
          <div class="d-flex flex-column flex-grow-1 border mb-2 overflow-auto">
            <object
                v-if="document"
                :data="'data:application/pdf;base64,'+document+'#view=Fit'"
                type="application/pdf"
                width="100%"
                height="100%"
            />
          </div>
          <div class="d-flex flex-column justify-content-end">
            <InputField
                v-model="code"
                id="code"
                name="code"
                :required="true"
                :mb="5"
                placeholder="Код"
                type="text"
            />
            <button class="btn btn-primary w-100" @click="sendCode">
          <span>
            <span class="indicator-progress" aria-hidden="true">
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
            <span class="indicator-label">Подтвердить</span>
          </span>
            </button>
          </div>
        </div>
      </div>
      <div v-else class="p-3 d-flex justify-content-center" style="height: 100dvh">
        <div class="col-12 col-md-6 card p-3 justify-content-center align-items-center">
          <i class="ki-duotone ki-cross fs-6x text-danger mb-5">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <h2>У вас нет доступа</h2>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="p-3 d-flex justify-content-center" style="height: 100dvh">
        <div class="col-12 col-md-6 card p-3 justify-content-center align-items-center">
          <i class="ki-duotone ki-check-circle fs-6x text-primary mb-5">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <h2>Согласие предоставлено</h2>
        </div>
      </div>
    </template>
  </template>
  <notifications position="top right" :pauseOnHover="true"/>
</template>

<script>
import axios from 'axios'
import InputField from "@/components/Fields/InputField.vue";
import states from "@/helpers/states";
import LoaderFull from "@/components/Main/LoaderFull.vue";
import crypto from "@/helpers/crypto";
export default {
  name: 'FunctionalOTPAgree',
  components: {LoaderFull, InputField},
  data() {
    return {
      isOtpSended: null,
      isOtpAccepted: null,
      document: null,
      ulid: this.$route.params.ulid,
      code: this.$route.query.code,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      axios.get('api/functional/otp/get-data', {params: {ulid: this.ulid}}).then(res => {
        let data = JSON.parse(crypto.decryptBackend(res.data))
        this.isOtpSended = data.isOtpSended
        this.isOtpAccepted = data.isOtpAccepted
        this.type = data.type
        this.document = data.document
      })
    },
    sendCode() {
      axios.post('api/functional/otp/accept', {code: this.code, ulid: this.ulid}).then(res => {
        if (res.data.result) {
          this.isOtpAccepted = true
        } else {
          this.$notifyError(res.data)
        }
      }).catch(err => {
        this.$notifyError(err)
      })
    }
  }
}
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.overflow-auto {
  max-height: calc(100% - 4rem);
  overflow-y: auto;
}

.btn {
  margin-top: auto;
}
</style>